import MainLayout from '../components/MainLayout';
import AddFeed from '../components/AddFeed';
import PageHeader from '../components/PageHeader';
import HeaderAuthButtons from '../components/HeaderAuthButtons';
import '../pages/DiscoverPage.css';
import { useFlowFormGlobal, FlowFormLeaveContext } from 't-lib-ui/structure';
import { sidebarLeaveHandler } from '../components/LeftSidebarFocus';

const AddFeedPage: React.FC = () => {
  const handleFeedAdded = (_feedId: string) => {
    // Stay on the page - user can click "View" button to navigate to the feed
  };

  useFlowFormGlobal('.flowForm.mainForm');


  return (
    <FlowFormLeaveContext.Provider value={sidebarLeaveHandler}>
    <MainLayout
      selectedFeed="add"
      right={({ onExpand }) => (
        <div className="discoverPage">
          <PageHeader title="Add Feed" onMenu={onExpand} rightContent={<HeaderAuthButtons />} />

          <AddFeed onFeedAdded={handleFeedAdded} autoFocus />
        </div>
      )}
      startWithLeftCollapsed={typeof window !== 'undefined' && window.innerWidth <= 750}
    />
    </FlowFormLeaveContext.Provider>
  );
};

export default AddFeedPage;
